import React from "react";
import classNames from "classnames";
import { FormGroup, HelpBlock } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw, ContentState } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import styles from "./RichEditor.scss";
import "./scrollPatch.css";
import labels from "./RichEditorLabels";

class RichEditor extends React.Component {
  constructor(props) {
    super(props);
    const editorState = this.initEditorState(props.input.value);
    this.state = {
      editorState,
      valid: true
    };
    this.changeValue(editorState);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.input.value !==
      draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
    ) {
      this.setState(
        {
          editorState: this.getUpdatedStateFromHTMLValue(nextProps.input.value)
        },
        () => {
          this.props.input.onChange(nextProps.input.value);
        }
      );
    }
  }

  getUpdatedStateFromHTMLValue(value) {
    const { editorState } = this.state;
    const contentBlock = htmlToDraft(value);
    const nextContentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );

    return EditorState.push(editorState, nextContentState);
  }

  initEditorState(value) {
    const html = value || "";
    const contentBlock = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    return EditorState.createWithContent(contentState);
  }

  handleChange(editorState) {
    this.setState({ editorState });
    this.changeValue(editorState);
  }

  changeValue(editorState) {
    const value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    const parseValue = value
      ? value.replace(/<[^>]*>/g, "").replace("&nbsp;", " ")
      : "";
    this.setState(
      {
        valid:
          parseValue.length <= this.props.maxLength && parseValue.length > 1
      },
      () => {
        this.props.input.onChange(value);
      }
    );
  }

  myBlockStyleFn(contentBlock) {
    const type = contentBlock.getType();
    if (
      type === "unstyled" ||
      type === "ordered-list-item" ||
      type === "unordered-list-item"
    ) {
      return styles.block;
    }
  }

  render() {
    const {
      name,
      input,
      help,
      className,
      meta: { touched, error, warning, valid }
    } = this.props;

    const validationState =
      (touched && valid && "success") ||
      (touched && error && "error") ||
      (touched && warning && "warning") ||
      null;

    const editorOptions = ["inline", "list", "remove", "history"];
    const editorInline = ["bold", "italic", "underline"];
    const editorList = ["unordered", "ordered"];

    const { editorState } = this.state;

    const value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    const parseValue = value
      ? value.replace(/<[^>]*>/g, "").replace("&nbsp;", " ")
      : "";
    const leftChar = this.props.maxLength - parseValue.length;

    return (
      <FormGroup validationState={validationState}>
        <Editor
          name={name}
          editorState={editorState}
          wrapperClassName={styles.wrapper}
          editorClassName={classNames(
            styles.editor,
            this.state.valid ? styles.success : styles.error,
            className
          )}
          toolbarClassName={styles.toolbar}
          blockStyleFn={this.myBlockStyleFn}
          onEditorStateChange={editorState => this.handleChange(editorState)}
          onBlur={input.onBlur}
          value={this.props.maxLength}
          placeholder={this.props.placeHolder}
          toolbar={{
            options: editorOptions,
            inline: { options: editorInline },
            list: { options: editorList }
          }}
          localization={{
            translations: labels
          }}
          stripPastedStyles={true}
        />
        {help && <HelpBlock className={styles.help}>{help}</HelpBlock>}
        {parseValue.length > 1 && !leftChar >= 0 && (
          <p className={leftChar >= 0 ? styles.charSign : styles.charSignErr}>
            {leftChar} characters left
          </p>
        )}
        {parseValue.length <= 1 && (
          <p className={styles.help}>
            {this.props.maxLength - 1} characters max
          </p>
        )}
        {touched && error && <p className={styles.error}>{error}</p>}
      </FormGroup>
    );
  }
}

export default RichEditor;



// WEBPACK FOOTER //
// ./src/components/common/richEditor/RichEditor.js